export default __webpack_public_path__ + "static/media/hatch-gribble-poster.5120939e.jpg";